import React from "react";
import { Container } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const useStyles = makeStyles({
  installSection: {
    background:
      `url("/Buoyancy Images/Vector06-7-06.png")`,
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    padding: "30px 20px",
    textAlign: "center",
    color: "#fff",
  },

  button: {
    fontSize: "1rem",
    padding: "12px 24px",
    borderRadius: "8px",
    backgroundColor: "#fff",
    color: "#FC6F5E",
    textTransform: "none",
    fontWeight: "bold",
    cursor: "pointer",
  },
});

const InstallSection: React.FC = () => {
  const classes = useStyles();
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });

  const handlePlayStoreClick = (): void => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.buoyancy.snaptoon&hl=en_IN",
      "_blank"
    );
  };

  return (
    <motion.div
      className={classes.installSection}
      ref={ref}
      initial={{ opacity: 0, y: 50 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 1 }}
    >
      <Container className="d-flex justify-around align-items-center">
        <h2>Install SwapToon and Start Using</h2>
        <div className="d-flex justify-between align-items-center gap-3">
          <motion.div
            className={classes.button}
            onClick={handlePlayStoreClick}
            initial={{ y: 0 }}
            whileHover={{ y: -5 }}
            animate={{ y: 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 10 }}
          >
            Play Store
          </motion.div>
        </div>
      </Container>
    </motion.div>
  );
};

export default InstallSection;
